interface RapidStorOptions {
  baseURL: string;
  token?: string;
  hiddenLocations: Array<string>;
  enabledLocations: Array<string>;
}

export const options: RapidStorOptions = {
  baseURL: import.meta.env.VITE_RAPIDSTOR_URL || "https://prod.rapidstorapp.com/",
  token: import.meta.env.VITE_RAPIDSTOR_API_TOKEN,
  hiddenLocations: ["L001", "L005", "L006", "LTEST005", "LSETUP"],
  enabledLocations: import.meta.env.VITE_RAPIDSTOR_ENABLED_LOCATIONS.split(","),
};
